export const CYCLING_PLACEHOLDERS = [
  "Build me a landing page for Black Friday...",
  "Create a beautiful product page for my new product launch...",
  "Suggest me some ideas to grow my conversion rates...",
  "Match my landing page to my ad...",
  "Create me a section that looks like...",
  "Build me a page based on this screenshot...",
  "Build me a form for collecting emails...",
  "Create me a quiz funnel to help customers make buying decisions...",
  "Build me an on-brand, high-converting landing page...",
  "Build me a mobile first page for DSP traffic...",
];
